import { convertListQuery } from "~/components/blocks/vod/top/util/convert-list-query";
import type { Href } from "~/const/hrefs";
import { PATHS } from "~/const/paths";
import type { G_FetchHomeQuery } from "~/lib/graphql";
import { G_HomeType } from "~/lib/graphql";

type Args = {
  headerItem: G_FetchHomeQuery["home"]["headerItems"][number];
  categoryId?: string;
};

/**
 * Infinity carouselでのheaderでhrefを生成する処理
 */
export const generateHref = ({ headerItem, categoryId }: Args) => {
  switch (headerItem.__typename) {
    case "VideoFreeItem": {
      const isGravure = categoryId === "gravure";
      const isSpot = headerItem.video.__typename === "VideoSpotLiveSeason";
      const preQuery =
        categoryId === undefined || isGravure
          ? { season: headerItem.video.id }
          : { id: categoryId, season: headerItem.video.id };
      const query = isSpot ? Object.assign(preQuery, { spot: true }) : preQuery;
      const pathname = isGravure ? PATHS.VOD_GRAVURE : PATHS.VOD;
      const href: Href = { pathname, query };
      return href;
    }
    case "VideoContentFreeItem": {
      const query =
        categoryId === undefined
          ? { season: headerItem.content.seasonId, content: headerItem.content.id }
          : { id: categoryId, season: headerItem.content.seasonId, content: headerItem.content.id };
      const href: Href = { pathname: PATHS.VOD, query };
      return href;
    }
    case "VideoListFreeItem": {
      const { query } = convertListQuery(headerItem.filter);
      const href: Href = { pathname: PATHS.VOD_LIST, query };
      return href;
    }
    case "URLFreeItem": {
      // memo: (okita) hrefを型付けしているため通常のurlだとcompile errorが発生するためcastする
      const href = headerItem.url as Href;
      return href;
    }
    case "HomeFreeItem": {
      const href: Href = (() => {
        switch (headerItem.pageType) {
          case G_HomeType.VideoHome:
            return PATHS.VOD;
          case G_HomeType.VideoSubPage:
            return { pathname: PATHS.VOD, query: { id: headerItem.homeId } };
          default:
            return PATHS.VOD;
        }
      })();
      return href;
    }
  }
};
